import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 87130 87565"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528323593808">
        <path
          d="M15728 82629c-562-119-820-445-820-820V18177c0-454 365-819 820-819h7622c454 0 820 365 820 819v49632c0 138-30 277-99 395l-7623 14000c-147 266-424 425-720 425zm819-63632v59593l5993-10988V18997h-5993z"
          className="fil0"
        />
        <path
          d="M19549 18997c-455 0-820-365-820-820v-7562c0-455 365-821 820-821 454 0 819 366 819 821v7572c0 445-375 810-819 810zM27743 82629c-562-119-818-445-818-820V18177c0-454 365-819 818-819h7623c453 0 819 365 819 819v49632c0 138-30 277-99 395l-7621 14000c-149 266-426 425-722 425zm820-63632v59593l5993-10988V18997h-5993z"
          className="fil0"
        />
        <path
          d="M31554 18997c-454 0-819-365-819-820v-7562c0-455 365-821 819-821 455 0 820 366 820 821v7572c0 445-365 810-820 810zM39749 82629c-562-119-820-445-820-820V18177c0-454 367-819 820-819h7623c454 0 819 365 819 819v49632c0 138-30 277-99 395l-7632 14000c-138 266-415 425-711 425zm820-63632v59593l5993-10988V18997h-5993z"
          className="fil0"
        />
        <path
          d="M43560 18997c-454 0-819-365-819-820v-7562c0-455 365-821 819-821 455 0 820 366 820 821v7572c0 445-365 810-820 810zM51755 82629c-562-119-820-445-820-820V18177c0-454 365-819 820-819h7622c455 0 820 365 820 819v49632c0 138-30 277-99 395l-7623 14000c-138 266-424 425-720 425zm819-63632v59593l5993-10988V18997h-5993z"
          className="fil0"
        />
        <path
          d="M55576 18997c-455 0-820-365-820-820v-7562c0-455 365-821 820-821 454 0 819 366 819 821v7572c0 445-365 810-819 810zM63770 82629c-562-119-818-445-818-820V18177c0-454 365-819 818-819h7623c454 0 819 365 819 819v49632c0 138-30 277-99 395l-7632 14000c-138 266-415 425-711 425zm820-63632v59593l5993-10988V18997h-5993z"
          className="fil0"
        />
        <path
          d="M67581 18997c-454 0-819-365-819-820v-7562c0-455 365-821 819-821 455 0 820 366 820 821v7572c0 445-365 810-820 810zM75105 87565H12015c-454 0-819-366-819-819v-7138c0-455 365-821 819-821 455 0 820 366 820 821v6318h61450v-6318c0-455 366-821 820-821s820 366 820 821v7138c0 453-366 819-820 819z"
          className="fil0"
        />
        <path
          d="M80288 80733c-454 0-819-366-819-819V11433H7671v68481c0 453-365 819-818 819-455 0-821-366-821-819V10615c0-455 366-821 821-821h73445c455 0 820 366 820 821v69299c-20 453-385 819-830 819z"
          className="fil0"
        />
        <path
          d="M81414 11433H5716C2566 11433 0 8867 0 5717 0 2568 2566 0 5716 0l75698 1c3150 0 5716 2567 5716 5716 0 3150-2566 5716-5716 5716zM5716 1640c-2250 0-4077 1826-4077 4077 0 2252 1827 4077 4077 4077h75698c2251 0 4077-1825 4077-4077 0-2251-1826-4077-4077-4077H5716z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
